// extracted by mini-css-extract-plugin
module.exports = {"TextCounter":"ItemBox_TextCounter__1WyAn"};